import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../../AuthContextWrapper";
import { OUTCOMES } from "../../../constants";
import { Box, Typography } from "@mui/material";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";
import flowersImage1 from "../../assets/flowers-1x.png";
import flowersImage15 from "../../assets/flowers-1.5x.png";
import flowersImage2 from "../../assets/flowers-2x.png";
import flowersImage3 from "../../assets/flowers-3x.png";

export enum Outcomes {
  continue = "Continue",
  alreadyStarted = "I already started probate",
}

export const SorryScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow } = useAuthContext()
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper title={""}>
      <Box>
        <img
          srcSet={`${flowersImage15} 1.5x, ${flowersImage2} 2x, ${flowersImage3} 3x`}
          src={flowersImage1}
          alt="Flowers"
          style={{ height: "156px" }}
        />
        <Typography component="h2" variant="h5">
          We’re so sorry for your loss
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, mb: 4, maxWidth: 580 }}>
          Losing a loved one is one of the most difficult experiences someone
          can go through. We’re here to make this as easy as possible so you can
          get back to what matters most.
        </Typography>
        <form onSubmit={handleComplete}>
          <ScreenFlowFormButtons onBack={() => navigate(-1)} />
        </form>
      </Box>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
